const Languages = {
  English: 0,
  Spanish: 1
};

export default Languages;